import React from 'react';
import styled from '@emotion/styled';

export const EntityThumbnailSettings = {
  large: {
    width: 80,
    height: 80,
    nameHeight: 40,
    badgeSize: 16,
    text: 12,
    margin: 2
  },
  small: {
    width: 50,
    height: 50,
    nameHeight: 30,
    badgeSize: 12,
    text: 10,
    margin: 1
  }
};

const EntityThumbContainer = styled.div(props => ({
  flex: `0 auto`,
  position: `relative`,
  width: props.size.width + `px`,
  textAlign: `center`,
  overflow: `hidden`,
  boxSizing: `border-box`,
  display: `flex`,
  flexDirection: `column`,
}));

const ThumbImg = styled.img(props => ({
  width: `100%`,
  height: `auto`,
}));

const CharacterName = styled.p`
  font-family: ${props => props.theme.fontFamily || 'Helvetica'};
  font-size: ${props => props.size.text}px;
  position: relative;
  width: 100%;
  text-align: left;
  margin: 0 auto;
  text-shadow: ${props => props.theme.textShadow};
  color: white;
  padding: 2px 0px;
  font-weight: 400;
  text-transform: ${props => (props.theme.textTransform ? props.theme.textTransform : 'uppercase')};
  border-top: ${props => (props.highlightColor ? `3px solid ${props.highlightColor}` : `none`)};
  outline-top: 2px solid black;
  box-sizing: border-box;
  line-height: 1;
  user-select: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ::before {
    position: absolute;
    top: ${props => (props.highlightColor ? '-4px' : '0px')};
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    background-color: black;
    height: 1px;
  }
`;

const DarkOverlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.66);
`;

const BadgeIconHolder = styled.div`
  height: ${props => `${props.size || '23'}px`};
  position: absolute;
  left: 0;
  top: 0;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-auto-flow: column;
  width: 100%;
  font-weight: bold;
  border-top: 1px solid #222;
  color: white;
`;

const BadgeIcon = styled.img`
  width: ${props => `${props.size || '23'}px`};
  height: ${props => `${props.size || '23'}px`};
  margin: 1px;
`;

export default ({
  name,
  imgSrc,
  small,
  size,
  isFilteredOut,
  badgeIcons,
  highlightColor,
}) => {
  size = size || (small ? EntityThumbnailSettings.small : EntityThumbnailSettings.large );
  return (
    <EntityThumbContainer
      size={size}
      highlightColor={highlightColor}
    >
      <div style={{maxHeight: size.height, overflow: `hidden`}}>
        <ThumbImg
          src={imgSrc}
          alt={name ? name + ' icon' : ''}
        />
      </div>
      {name && 
        <CharacterName
          size={size}
          highlightColor={highlightColor}
        >
          {name}
        </CharacterName>
      }
      {badgeIcons && badgeIcons.length !== 0 && (
        <BadgeIconHolder>
          {badgeIcons.map(icon => {
            return icon.uri && <BadgeIcon src={icon.uri} size={size.badgeSize} />;
          })}
        </BadgeIconHolder>
      )}
      {isFilteredOut ? <DarkOverlay /> : <></>}
    </EntityThumbContainer>
  )
};
